import { Copiavel, Loading, OmnijusCard } from "@omnijus/common";
import { showToast } from "../../../lib/toast";
import React, { useEffect, useState } from "react";
import { AudienciaService } from "../../../services/audiencia/audiencia-service";
import { DadosParceiroAudiencia } from "../../../services/audiencia/models/dados-parceiro-audiencia";
import { CampoDetalhamento } from "../../../shared/campo-detalhamento/campo-detalhamento";
import styles from "./detalhamento-audiencia.module.scss";

interface DetalhamentoAudienciaDadosParceiroProps {
    idAudiencia: string;
}

export const DetalhamentoAudienciaDadosParceiro = (props: DetalhamentoAudienciaDadosParceiroProps) => {
    const [promise, setPromise] = useState<Promise<DadosParceiroAudiencia | undefined>>();

    useEffect(() => {
        setPromise(AudienciaService.obterDadosSolicitacaoParceiro(props.idAudiencia));
    }, [props.idAudiencia]);

    return (
        <OmnijusCard
            header={<h3>Dados no Parceiro</h3>}
            body={
                <Loading promise={promise}>
                    {(dadosParceiro) =>
                        dadosParceiro === undefined ? (
                            <p>Não encontrado</p>
                        ) : (
                            <ul className={styles["dados-parceiro"]}>
                                <li className={styles["item"]}>
                                    <CampoDetalhamento label="Observações" value={dadosParceiro.observacoes || "-"} />
                                </li>
                                <li className={styles["item"]}>
                                    <CampoDetalhamento
                                        label="Proposta de Acordo"
                                        value={dadosParceiro.propostaAcordo || "-"}
                                    />
                                </li>
                                <li className={styles["item"]}>
                                    <CampoDetalhamento
                                        label="Instruções de Teleaudiência"
                                        value={dadosParceiro.instrucoesTeleaudiencia || "-"}
                                    />
                                </li>
                                <li className={styles["item"]}>
                                    <CampoDetalhamento
                                        label="ID da Audiência"
                                        value={
                                            dadosParceiro.idAudiencia ? (
                                                <Copiavel
                                                    informacaoCopiavel={dadosParceiro.idAudiencia}
                                                    mensagem="ID da audiência no parceiro copiado"
                                                    onCopiado={() => showToast("ID da audiência no parceiro copiado")}
                                                />
                                            ) : (
                                                "-"
                                            )
                                        }
                                    />
                                </li>
                            </ul>
                        )
                    }
                </Loading>
            }
        />
    );
};
